'use client';
import React, { useState } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { ChevronDown } from 'lucide-react';

const labelFor = (value) => {
	if (value === 'desc') return 'Descending';
	if (value === 'asc') return 'Ascending';
	return 'Default';
};

const SortControl = ({ value, onChange, label = 'Sort' }) => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleOpen = (e) => setAnchorEl(e.currentTarget);
	const handleClose = () => setAnchorEl(null);
	const handleSelect = (dir) => {
		onChange(dir);
		handleClose();
	};

	return (
		<>
			<button
				type='button'
				onClick={handleOpen}
				className='flex items-center gap-1 text-sm text-gray-700 hover:text-black'
			>
				<span>
					{label}: <span className='font-medium'>{labelFor(value)}</span>
				</span>
				<ChevronDown size={16} />
			</button>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				<MenuItem
					selected={value === 'asc'}
					onClick={() => handleSelect('asc')}
				>
					Ascending
				</MenuItem>
				<MenuItem
					selected={value === 'desc'}
					onClick={() => handleSelect('desc')}
				>
					Descending
				</MenuItem>
			</Menu>
		</>
	);
};

export default SortControl;
